import PropertyCardList from './PropertyCardList';

export default PropertyCardList;
